document.addEventListener('DOMContentLoaded', function () {
  const $ = s => document.querySelector(s);
  const $$ = s => document.querySelectorAll(s);
  const tiles = $$('[qty-tile]');
  const numDisplay = $('[qty="number"]');
  const totalDisplay = $('[product-info="total-qty"]');
  const btn = $('[ve="add-to-cart"]');
  const form = $('[ve="product-form"] form') || $('[ve="product-form"]')?.querySelector('form');
  const unitTypeDisplay = $('[product-info="unit-type"]');
  if (!form) return console.error('Product form not found');
  let qtyInput = form.querySelector('input[name="quantity"]') ||
    form.querySelector('[x-model="quantity"]') || form.querySelector('#quantity');
  if (!qtyInput) {
    qtyInput = Object.assign(document.createElement('input'), {
      type: 'hidden', name: 'quantity', id: 'quantity', value: 3
    });
    form.appendChild(qtyInput);
  }

  // --- Preselected option set here ---
  const DEFAULT = 1, MIN = 1, MAX_TILE = 3;
  const PER_CASE = parseInt(btn?.dataset.unitsPerCase) || 12;
  let qty = DEFAULT, ready = false, submitting = false;

  // --- Observer management ---
  let rcObserver = null;
  let rcObserverTarget = null;
  let trackedPlanSelect = null;

  function pauseObserver() {
    if (rcObserver) rcObserver.disconnect();
  }

  function resumeObserver() {
    if (rcObserver && rcObserverTarget) {
      rcObserver.observe(rcObserverTarget, { childList: true, subtree: true });
    }
  }

  // --- Live button element getters ---
  // ReCharge may destroy and recreate elements inside the button,
  // so we re-query every time instead of caching stale references.
  function getBtnLabel() { return btn?.querySelector('[product-info="type"]'); }
  function getBtnInfo() { return btn?.querySelector('.ve-product-addtocart-info-wrapper'); }
  function getBtnFreq() { return btn?.querySelector('[product-info="frequency"]'); }
  function getBtnPrice() { return btn?.querySelector('[product-info="price"]'); }

  // --- ReCharge helpers ---
  function getRcWidget() {
    const el = $('recharge-subscription-widget');
    return el?.shadowRoot || null;
  }

  function getRcPlanSelect() {
    const shadow = getRcWidget();
    if (!shadow) return null;
    const sellingPlans = shadow.querySelector('rc-selling-plans');
    const innerShadow = sellingPlans?.shadowRoot;
    return innerShadow?.querySelector('select[name="rc_plan"]') || null;
  }

  function ensurePlanSelectListener() {
    const planSelect = getRcPlanSelect();
    if (planSelect && planSelect !== trackedPlanSelect) {
      trackedPlanSelect = planSelect;
      planSelect.addEventListener('change', () => {
        updateButtonInfo();
      });
    }
  }

  function getRcState() {
    const shadow = getRcWidget();
    if (!shadow) return null;
    const selectedRadio = shadow.querySelector('input[name="purchaseOption"]:checked');
    if (!selectedRadio) return null;
    const isSubscription = selectedRadio.value === 'subscription';
    const config = window.SubscriptionWidgetConfig?.formattedPrices;
    const variantId = $('recharge-subscription-widget')?.getAttribute('default-variant-id');
    const variantPrices = config?.[variantId];
    if (isSubscription) {
      const planSelect = getRcPlanSelect();
      const planId = planSelect?.value;
      const planOption = planSelect?.selectedOptions?.[0];
      const optionText = planOption?.textContent?.trim() || '';
      const freqMatch = optionText.match(/^([\d]+ \w+)/);
      const frequency = freqMatch ? freqMatch[1] : '';
      const price = variantPrices?.sellingPlans?.[planId]?.price || variantPrices?.discounted || '';
      return {
        type: 'Subscribe',
        frequency: frequency ? `(Every ${frequency})` : '',
        price,
        originalPrice: variantPrices?.unit || '',
        isSubscription: true
      };
    }
    return {
      type: 'Add to Cart',
      frequency: '',
      price: variantPrices?.unit || '',
      originalPrice: '',
      isSubscription: false
    };
  }

  function calcTotal(priceStr) {
    const num = parseFloat(priceStr.replace(/[^0-9.]/g, ''));
    if (isNaN(num)) return priceStr;
    return '$' + (num * qty).toFixed(2);
  }

  function formatTotal(priceStr) {
    return calcTotal(priceStr);
  }

  // --- ReCharge Price Replacement ---
  function updateRcPrices() {
    const shadow = getRcWidget();
    if (!shadow) return;

    const config = window.SubscriptionWidgetConfig?.formattedPrices;
    const variantId = $('recharge-subscription-widget')?.getAttribute('default-variant-id');
    const variantPrices = config?.[variantId];
    if (!variantPrices) return;

    pauseObserver();

    // --- Subscription option prices ---
    const subPrices = shadow.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices');
    if (subPrices) {
      subPrices.querySelectorAll(':scope > span:not(.ve-rc-injected)').forEach(el => {
        el.style.display = 'none';
      });

      const planSelect = getRcPlanSelect();
      const planId = planSelect?.value;
      const subPrice = variantPrices?.sellingPlans?.[planId]?.price || variantPrices?.discounted || '';
      const origPrice = variantPrices?.unit || '';

      let veStrike = subPrices.querySelector('.ve-rc-strike-total');
      if (!veStrike) {
        veStrike = document.createElement('span');
        veStrike.className = 'rc-price strike-through text-muted ve-rc-injected ve-rc-strike-total';
        veStrike.setAttribute('part', 'rc-purchase-option__original-price');
        subPrices.prepend(veStrike);
      }
      if (origPrice && subPrice && origPrice !== subPrice) {
        veStrike.textContent = calcTotal(origPrice);
        veStrike.style.display = '';
      } else {
        veStrike.style.display = 'none';
      }

      let veDiscount = subPrices.querySelector('.ve-rc-discount-total');
      if (!veDiscount) {
        veDiscount = document.createElement('span');
        veDiscount.className = 'rc-price ve-rc-injected ve-rc-discount-total';
        veDiscount.setAttribute('part', 'rc-purchase-option__discounted-price');
        subPrices.appendChild(veDiscount);
      }
      veDiscount.textContent = subPrice ? calcTotal(subPrice) : '';
      veDiscount.style.display = subPrice ? '' : 'none';
    }

    // --- One-time option price ---
    const otPrices = shadow.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
    if (otPrices) {
      otPrices.querySelectorAll(':scope > span:not(.ve-rc-injected)').forEach(el => {
        el.style.display = 'none';
      });

      const otPrice = variantPrices?.unit || '';

      let veOt = otPrices.querySelector('.ve-rc-ot-total');
      if (!veOt) {
        veOt = document.createElement('span');
        veOt.className = 'rc-price ve-rc-injected ve-rc-ot-total';
        veOt.setAttribute('part', 'rc-purchase-option__price');
        otPrices.appendChild(veOt);
      }
      veOt.textContent = otPrice ? calcTotal(otPrice) : '';
      veOt.style.display = otPrice ? '' : 'none';
    }

    resumeObserver();
  }

  function updateButtonInfo() {
    const btnLabel = getBtnLabel();
    const btnFreq = getBtnFreq();
    const btnPrice = getBtnPrice();

    const state = getRcState();
    if (!state) {
      if (btnLabel) btnLabel.textContent = 'Add to Cart';
      if (btnFreq) btnFreq.style.display = 'none';
      if (btnPrice) btnPrice.style.display = 'none';
      return;
    }
    if (btnLabel) btnLabel.textContent = state.type;
    if (btnFreq) {
      btnFreq.textContent = state.frequency;
      btnFreq.style.display = state.frequency ? '' : 'none';
    }
    if (btnPrice) {
      btnPrice.textContent = state.price ? formatTotal(state.price) : '';
      btnPrice.style.display = state.price ? '' : 'none';
    }
    updateRcPrices();
  }

  function fullRefresh() {
    ensurePlanSelectListener();
    updateButtonInfo();
  }

  // --- Quantity UI ---
  function updateUI() {
    qtyInput.value = qty;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.jQuery) jQuery(qtyInput).trigger('change');
    if (numDisplay) numDisplay.textContent = qty;
    if (totalDisplay) totalDisplay.textContent = qty * PER_CASE;
    const unitType = btn?.dataset.unitType || '';
    if (unitTypeDisplay) unitTypeDisplay.textContent = unitType;
    tiles.forEach(t => {
      const tileQty = parseInt(t.getAttribute('qty-tile'));
      const isActive = tileQty === qty || (tileQty === MAX_TILE && qty >= MAX_TILE);
      t.classList.toggle('current', isActive);
      const titleEl = t.querySelector('[qty="tile-title"]');
      if (titleEl) {
        const suffix = (tileQty === MAX_TILE && qty > MAX_TILE) ? '+' : '';
        titleEl.textContent = (tileQty * PER_CASE) + suffix + (unitType ? ' ' + unitType : '');
      }
    });
    updateRcPrices();
  }

  function setQty(v) {
    qty = Math.max(MIN, parseInt(v) || MIN);
    updateUI();
    updateButtonInfo();
  }

  function setBtnState(enabled, label, showInfo) {
    if (!btn) return;
    const btnLabel = getBtnLabel();
    const btnInfo = getBtnInfo();
    btn.style.pointerEvents = enabled ? 'auto' : 'none';
    btn.style.opacity = enabled ? '1' : '0.5';
    if (btnLabel && label !== undefined) btnLabel.textContent = label;
    if (btnInfo && showInfo !== undefined) btnInfo.style.display = showInfo ? '' : 'none';
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
  }

  function showError(msg) {
    let el = $('.cart-notification');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cart-notification';
      el.style.cssText =
        'position:fixed;top:20px;right:20px;padding:16px 24px;background:#ef4444;color:#fff;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,.1);z-index:9999;font-size:14px;font-weight:500;transition:opacity .3s,transform .3s;pointer-events:none';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
    el.style.pointerEvents = 'auto';
    setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(-20px)';
      el.style.pointerEvents = 'none';
    }, 3000);
  }

  // --- Cart ---
  async function addToCart(e) {
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (submitting || !ready) return;
    submitting = true;
    const btnLabel = getBtnLabel();
    const savedLabel = btnLabel?.textContent || '';
    setBtnState(false, 'Adding...', false);
    const vid = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    if (!vid) {
      showError('Product variant not found');
      submitting = false;
      return setBtnState(true, savedLabel, true);
    }
    const item = { id: vid.value, quantity: qty };
    const props = {};
    const systemFields = ['id', 'quantity', 'form_type', 'utf8'];
    const propertyFields = ['properties', 'gift_message', 'engraving', 'note'];

    new FormData(form).forEach((v, k) => {
      if (systemFields.includes(k)) return;
      if (k.startsWith('properties[')) {
        const propKey = k.match(/properties\[(.*?)\]/)?.[1];
        if (propKey) props[propKey] = v;
      } else if (propertyFields.includes(k)) {
        props[k] = v;
      } else {
        item[k] = /^\d+$/.test(v) ? parseInt(v) : v;
      }
    });

    if (Object.keys(props).length) {
      item.properties = props;
    }

    console.log('Adding to cart:', item);

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!res.ok) throw new Error('Failed to add to cart');
      const data = await res.json();
      console.log('Cart response:', data);
      emit('cartupdated', data.items);
      emit('toggleminicart');
      emit('showcartmessage', { status: data.status, message: data.message, description: data.description });
      window.LiquifyHelper?.handleTriggerClick?.();
      if (window.jQuery) jQuery(document).trigger('cart:updated');
      window.theme?.cart?.refresh?.();
      qty = DEFAULT;
    } catch (err) {
      console.error('Liquify - addToCart error:', err);
      showError('Failed to add to cart. Please try again.');
      emit('showcartmessage', { status: err.status, message: err.message, description: err.description });
    } finally {
      submitting = false;
      setBtnState(true, savedLabel, true);
      updateUI();
      updateButtonInfo();
    }
  }

  // --- Event listeners ---
  const stop = e => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };

  tiles.forEach(t => t.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    setQty(parseInt(this.getAttribute('qty-tile')));
  }));

  $('[qty="down"]')?.addEventListener('click', e => { stop(e); setQty(qty - 1); }, true);
  $('[qty="up"]')?.addEventListener('click', e => { stop(e); setQty(qty + 1); }, true);

  btn?.addEventListener('click', e => {
    if (e.target.closest('[qty="up"]') || e.target.closest('[qty="down"]')) return;
    addToCart(e);
  });

  form.addEventListener('submit', addToCart);

  // --- Watch ReCharge widget for changes ---
  function observeRcWidget() {
    const shadow = getRcWidget();
    if (!shadow) return false;

    // Watch radio buttons — delay to let ReCharge finish re-rendering
    shadow.querySelectorAll('input[name="purchaseOption"]').forEach(radio => {
      radio.addEventListener('change', () => {
        updateButtonInfo();
        setTimeout(fullRefresh, 300);
        setTimeout(fullRefresh, 600);
      });
    });

    // Watch frequency dropdown
    ensurePlanSelectListener();

    // Watch for ReCharge re-renders (e.g. variant changes)
    let debounceTimer = null;
    rcObserverTarget = shadow;
    rcObserver = new MutationObserver(() => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
        fullRefresh();
      }, 150);
    });
    resumeObserver();

    return true;
  }

  // --- Init ---
  setBtnState(false);
  updateUI();
  let attempts = 0;
  const check = setInterval(() => {
    if (++attempts >= 15 || window.ReCharge || $('[data-recharge]') || $('.recharge-widget')) {
      clearInterval(check);
      setTimeout(() => {
        updateUI();
        updateButtonInfo();
        observeRcWidget();
        ready = true;
        setBtnState(true);
      }, 100);
    }
  }, 200);
});